import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth";
import { Button } from "../components/ui";
export default function NotFound() {
  const { t } = useTranslation("ui");
  const { authenticated } = useAuth();
  return (
    <section className="vl-public-content">
      <span className="vl-eyebrow">404</span>
      <h1>{t("notFoundTitle")}</h1>
      <p>{t("notFoundText")}</p>
      <Button asChild>
        <Link to={authenticated ? "/products" : "/"}>
          {t(authenticated ? "backProducts" : "backHome")}
        </Link>
      </Button>
    </section>
  );
}
